import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AddTreatmentItem, TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-treatment-element',
  templateUrl: './treatment-element.component.html',
  styleUrl: './treatment-element.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent, TooltipModule, ReactiveFormsModule, TranslatePipe],
})
export class TreatmentElementComponent {
  @Input({ required: true }) public treatment!: AddTreatmentItem;

  @Output() public readonly addTreatment = new EventEmitter<AddTreatmentItem>();

  public onAddClick(): void {
    this.addTreatment.emit(this.treatment);
  }
}
